export default __webpack_public_path__ + "static/media/Carlindo_Junior_CV.28876121.pdf";